import { BaseComponent } from '../../../layout/main/base.component';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';

import { Branch, ItemCode, ProcessStatus } from 'src/app/api/models/web-booking.models';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-select-consultation',
  templateUrl: './select-consultation.component.html',
  styleUrls: ['./select-consultation.component.css']
})
export class SelectConsultationComponent extends BaseComponent implements OnInit, AfterViewInit {

  groups: any[];

  public modalRef: BsModalRef;
  @ViewChild('covidUpdate') covidUpdate: TemplateRef<any>;
  @ViewChild('covidBlocker') covidBlocker: TemplateRef<any>;
  @ViewChild('unlimtedModal') unlimtedModal: TemplateRef<any>;
  @ViewChild('twoYearsTransaction') twoYearsTransaction: TemplateRef<any>;
  @ViewChild('isNewCustomerDialog') isNewCustomerDialog: TemplateRef<any>;

  public feverOrSorTroat: any = null;
  public contactWithConvidPatient: any = null;
  public travell30Days: any = null;
  treatment: ItemCode;

  ngOnInit(): void {
    if (this.app.storageService.getItem(AppConstants.BookingProcessStatus) === ProcessStatus.ConfirmAppointment.toString()) {
      this.app.router.navigate([AppConstants.RouteServiceConfirmation]);
      return;
    }
  }

  ngAfterViewInit(): void {
    this.baseTriggerChild.subscribe(
      event => {
        this.app.pageTitle = "Book an Appointment";
        this.getTreatmentsByGroup(this.app.branch);        

        if (
          (this.app.customer.isNewCustomer === false ||
            this.app.customer.isNewCustomer === undefined ||
            this.app.customer.isNewCustomer === null) &&
          (this.app.customer.is2YearLastTransaction === false ||
            this.app.customer.is2YearLastTransaction === undefined ||
            this.app.customer.is2YearLastTransaction === null) &&
          (this.app.customer.hasPaidAppointment === true)) {
          console.log(1);
        }
      });

    this.start();
  }

  getTreatments(branch: Branch): void {
    const model = { branchId: branch.branchId };
    this.app.webBookingService.GetTreatments(model).subscribe(
      data => {
        this.app.spinner.hide();
        this.showDialogForCustomer();
      },
      error => {
        this.app.spinner.hide();
        this.showErrorMessage(error);
      }
    );
  }

  getTreatmentsByGroup(branch: Branch): void {
    const model = { branchId: branch.branchId };
    this.app.webBookingService.GetTreatmentByGroup(model).subscribe(
      data => {
        this.app.spinner.hide();
        this.groups = data;
        this.showDialogForCustomer();
        this.scrollTo();
      },
      error => {
        this.app.spinner.hide();
        this.showErrorMessage(error);
      }
    );
  }

  showDialogForCustomer(): void {
    if (this.app.stringService.isEmpty(this.app.customer)) { return; }
    if (this.app.alreadyAnswer) { return; }
    if (this.app.customer.isNewCustomer) {
      this.modalRef = this.app.modalService.show(
        this.isNewCustomerDialog,
        {
          class: 'modal-lg modal-dialog-centered modal-dialog-scrollable',
          ignoreBackdropClick: true,
          keyboard: false
        }
      );
      return;
    }
    if (this.app.customer.is2YearLastTransaction) {
      this.modalRef = this.app.modalService.show(
        this.twoYearsTransaction,
        {
          class: 'modal-lg modal-dialog-centered modal-dialog-scrollable',
          ignoreBackdropClick: true,
          keyboard: false
        }
      );
      return;
    }
  }

  // groupServicesAndPackagesByInfo(serviceAndPackages: ItemCode[]): void {
  //   const tempList = new Array<OrderedServicesAndPackagesList>();

  //   for (const itm1 of serviceAndPackages) {
  //     let count = 0;
  //     for (const group of tempList) {
  //       if (itm1.info === group.info) {
  //         count++;
  //       }
  //     }

  //     if (count < 1) {
  //       const grp = new OrderedServicesAndPackagesList();
  //       grp.info = itm1.info;
  //       const itemList = Array<ItemCode>();

  //       for (const itm2 of serviceAndPackages) {
  //         if (itm2.info === itm1.info) {
  //           itemList.push(itm2);
  //         }
  //       }

  //       grp.items = itemList;

  //       if (grp.info != null) {
  //         tempList.push(grp);
  //       }
  //     }
  //   }

  //   this.servicePackageList = tempList;


  //   // Returns Services and Packages in alphabetical.
  //   this.servicePackageList.sort(function compare(a, b): number {
  //     let comparison = 0;
  //     if (a.info > b.info) {
  //       comparison = 1;
  //     } else if (a.info < b.info) {
  //       comparison = -1;
  //     }
  //     return comparison;
  //   });

  // }

  setSelectedService(service: ItemCode): void {
    if (service.unlimited) {
      this.openModal(this.unlimtedModal);
    }
    else {
      if (service.newClientTreatment) {
        this.treatment = service;
        this.openModal(this.covidUpdate);
      }
      else {
        const treatments = [];
        treatments.push(service);
        this.app.storageService.setItem(AppConstants.BookingSelectedTreatment, JSON.stringify(treatments));
        this.app.router.navigate([AppConstants.RouteSelectPractitioner]);
      }
    }
  }

  openModal(template: TemplateRef<any>): void {
    if (this.app.config.enableCovid) {
      this.feverOrSorTroat = null;
      this.contactWithConvidPatient = null;
      this.travell30Days = null;
      this.modalRef = this.app.modalService.show(
        template,
        {
          class: 'modal-lg modal-dialog-centered modal-dialog-scrollable',
          ignoreBackdropClick: true,
          keyboard: false
        }
      );
    }
    else {
      const treatments = [];
      treatments.push(this.treatment);
      this.app.storageService.setItem(AppConstants.BookingSelectedTreatment, JSON.stringify(treatments));
      this.app.router.navigate([AppConstants.RouteSelectPractitioner]);
    }
  }

  clodeDialog(): void {
    this.modalRef.hide();
  }

  confirmMessageDialog(): void {
    this.app.alreadyAnswer = true;
    this.modalRef.hide();
  }

  checkCovid(): boolean {
    if (this.modalRef == null || this.modalRef === undefined) { return false; }
    if (this.contactWithConvidPatient === null) {
      this.showErrorMessage('Please answer the following question.');
      return true;
    }
    if (this.feverOrSorTroat === null) {
      this.showErrorMessage('Please answer the following question.');
      return true;
    }
    if (this.travell30Days === null) {
      this.showErrorMessage('Please answer the following question.');
      return true;
    }

    if (this.contactWithConvidPatient === 'true' || this.feverOrSorTroat === 'true' || this.travell30Days === 'true') {
      this.modalRef.hide();
      this.openModal(this.covidBlocker);
      return true;
    }
    else {const treatments = [];
      treatments.push(this.treatment);
      this.app.storageService.setItem(AppConstants.BookingSelectedTreatment, JSON.stringify(treatments));
      this.app.router.navigate([AppConstants.RouteSelectPractitioner]);
      this.modalRef.hide();
      return false;
    }
  }

  filterService(service: ItemCode): boolean {
    if (this.app.stringService.isEmpty(this.app.customer) || this.app.configService.config.disableNewClientFilter) {
      return true;
    }

    if (service.unlimited) { return true; }

    if ((this.app.customer.isNewCustomer === true ||
      this.app.customer.is2YearLastTransaction === true ||
      this.app.customer.hasPaidAppointment === false) &&
      service.newClientTreatment === true) {
      return true;
    }

    if (
      (this.app.customer.isNewCustomer === false ||
        this.app.customer.isNewCustomer === undefined ||
        this.app.customer.isNewCustomer === null) &&
      (this.app.customer.is2YearLastTransaction === false ||
        this.app.customer.is2YearLastTransaction === undefined ||
        this.app.customer.is2YearLastTransaction === null) &&
      (service.newClientTreatment === false ||
        service.newClientTreatment === undefined ||
        service.newClientTreatment === null) &&
      (this.app.customer.hasPaidAppointment === true)) {
      return true;
    }
    
    return false;
  }
}

export class OrderedServicesAndPackagesList {
  public info: string;
  public items: ItemCode[];
}
